import {
  FORMULARIO_GLOBAL_QUESTION_TYPES,
  getQuestionMatrixValidationErrors,
} from './FormularioGlobalQuestionTypes';

export const getMatrixItemKey = (item, index) =>
  item.id > 0
    ? `id-${item.id}`
    : item._formularioGlobalClientId || `order-${item.ordem || index + 1}`;

export const getMatrixAnswerSelections = (question, value) => {
  const rows = new Set((question.linhas || []).map(getMatrixItemKey));
  const columns = new Set((question.colunas || []).map(getMatrixItemKey));
  const seen = new Set();

  return (Array.isArray(value) ? value : []).filter((selection) => {
    if (
      !selection ||
      !rows.has(selection.linhaKey) ||
      !columns.has(selection.colunaKey)
    ) {
      return false;
    }

    const key = JSON.stringify([selection.linhaKey, selection.colunaKey]);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const serializeMatrixAnswer = (question, value) => {
  const rows = new Map(
    (question.linhas || []).map((item, index) => [
      getMatrixItemKey(item, index),
      item,
    ])
  );
  const columns = new Map(
    (question.colunas || []).map((item, index) => [
      getMatrixItemKey(item, index),
      item,
    ])
  );

  return getMatrixAnswerSelections(question, value)
    .filter(
      ({ linhaKey, colunaKey }) =>
        rows.get(linhaKey).id > 0 && columns.get(colunaKey).id > 0
    )
    .map(({ linhaKey, colunaKey }) => ({
      linhaId: rows.get(linhaKey).id,
      colunaId: columns.get(colunaKey).id,
    }));
};

export const deserializeMatrixAnswer = (question, selections = []) => {
  const rows = new Map(
    (question.linhas || [])
      .filter((item) => item.id > 0)
      .map((item, index) => [String(item.id), getMatrixItemKey(item, index)])
  );
  const columns = new Map(
    (question.colunas || [])
      .filter((item) => item.id > 0)
      .map((item, index) => [String(item.id), getMatrixItemKey(item, index)])
  );

  return getMatrixAnswerSelections(
    question,
    (Array.isArray(selections) ? selections : []).map((selection) => ({
      linhaKey: rows.get(String(selection?.linhaId)),
      colunaKey: columns.get(String(selection?.colunaId)),
    }))
  );
};

export const getMatrixAnswerValidationError = (question, value) => {
  if (question.tipo !== FORMULARIO_GLOBAL_QUESTION_TYPES.MATRIZ_SELECAO)
    return null;

  if (Object.keys(getQuestionMatrixValidationErrors(question)).length > 0) {
    return 'msgRespostaMatrizInvalida';
  }

  const selections = getMatrixAnswerSelections(question, value);
  if (
    (value != null && !Array.isArray(value)) ||
    (Array.isArray(value) && selections.length !== value.length)
  ) {
    return 'msgRespostaMatrizInvalida';
  }

  const selectedRows = new Set();
  for (const { linhaKey } of selections) {
    if (
      !question.permitirMultiplaSelecaoPorLinha &&
      selectedRows.has(linhaKey)
    ) {
      return 'msgRespostaMatrizInvalida';
    }
    selectedRows.add(linhaKey);
  }

  return question.obrigatoria && selectedRows.size !== question.linhas.length
    ? 'msgRespondaTodasLinhasMatriz'
    : null;
};
